import { Injectable, Injector } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { CookieService } from "ngx-cookie";
import { SiDataService } from "./services/si-data.service";
import { SiCustomerCommonService } from "./si-customers/si-common-customer.service";
declare let $;
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private router: Router,
    private siDataService: SiDataService,
    private cookieService: CookieService,
    private toastrService: ToastrService,
    private siCustomerCommonService: SiCustomerCommonService
  ) {}
  /**
   * Intercepts token
   * @param request
   * @param next
   * @returns intercept
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // IMPORTANT: AuthService needs to be injected using injector to avoid cyclic dependency
    const siAuthenticationService = this.injector.get(SiAuthenticationService);

    const httpHeaders = {
      username: siAuthenticationService.getUser(),
      version: "CCID-Op-Insights-5.3.48-RELEASE-1792683024",
      authtype: siAuthenticationService.getAuthType() || "nonsso",
    };
    if (siAuthenticationService.getAuthToken()) {
      httpHeaders["authtoken"] = siAuthenticationService.getAuthToken();
    }
    if (siAuthenticationService.getWebToken()) {
      httpHeaders["webtoken"] = siAuthenticationService.getWebToken();
    }
    if (siAuthenticationService.getActiveCustomer()) {
      httpHeaders["orgname"] = siAuthenticationService.getActiveCustomer();
    }
    // if(request.method == 'POST')
    //   if(this.cookieService.get("pac4jCsrfToken")){
    //     httpHeaders["pac4jCsrfToken"] = this.cookieService.get("pac4jCsrfToken");
    //   }

    if (
      siAuthenticationService.getWebToken() ||
      siAuthenticationService.getAuthToken()
    ) {
      request = request.clone({
        setHeaders: httpHeaders,
      });
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            if (event.headers.get("versionmatched") === "false") {
              $("#isVersionMismatch").modal("show");
            }
            return event;
          }
        },
        (error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401 || error.status === 403) {
              // Standalone route (e.g. auditlog) — show session-expired modal
              // without destroying the main app session navigation.
              if (sessionStorage.getItem('standaloneRoute')) {
                //this.siCustomerCommonService.sessionExpired.next();
                return throwError(error);
              }
              if (siAuthenticationService.isSSO()) {
                // delete auth token only
                if (siAuthenticationService.getAuthToken()) {
                  this.cookieService.remove("authtoken", {
                    domain: window.location.host,
                  });
                }
                if (siAuthenticationService.getWebToken()) {
                  this.cookieService.remove("webtoken", {
                    domain: window.location.host,
                  });
                }
                this.siDataService.clearIndexedDB().subscribe({
                  next: (response) => {
                    this.toastrService.error(error.error, "Oops !!", {});
                    if (
                      siAuthenticationService.siAuthenticationConfig
                        .logoutRoute !== undefined &&
                      siAuthenticationService.siAuthenticationConfig
                        .logoutRoute !== ""
                    ) {
                      this.router.navigate(
                        [
                          siAuthenticationService.siAuthenticationConfig
                            .logoutRoute,
                        ],
                        {
                          queryParams: { isLogout: false },
                          skipLocationChange: true,
                        }
                      );
                    }
                  },
                  error: (err) => {},
                });
              } else {
                // delete full API response
                siAuthenticationService.deleteAPIResponse();
                this.siDataService.clearIndexedDB().subscribe({
                  next: (response) => {
                    if (typeof error.error === "string") {
                      this.toastrService.error(error.error, "Oops !!", {});
                    } else {
                      this.toastrService.error(
                        error.error.message,
                        "Oops !!",
                        {}
                      );
                    }
                    this.router.navigate(['/kclogoutredirect'], { queryParams: { logout: true } });
                  },
                  error: (err) => {
                    this.router.navigate(['/kclogoutredirect'], { queryParams: { logout: true } });
                  },
                });
                this.router.navigate(['/kclogoutredirect'], { queryParams: { logout: true } });
              }
              return throwError(error);
            }
            try {
              this.toastrService.error(
                error.error.responseObject.errorResponse.reason,
                "Oops !!"
              );
            } catch (err) {
              try {
                this.toastrService.error(error.error.errors[0]);
              } catch (err) {
                return throwError(error);
              }
            }
            return throwError(error);
          }
        }
      )
    );
  }
}
